export default __webpack_public_path__ + "static/media/LawnMaintainence.dc0e7a81.png";